import React, { Component } from 'react';
import './recognitionsPage.css';
import EmpOfMonth from './../images/recognitions/EmployeOfTheMonthNomination.png';
import Appreciation from './../images/recognitions/Appreciations_Atmecs_Kudos.jpg';
import NewsLetter from './../images/recognitions/Appreciations_NewsLetter.jpg';
import SummitAward from './../images/recognitions/SummitAward.jpg';

interface Dictionary<T> {
    [Key: string]: T;
}

const RecognitionsExplanation: Dictionary<string> =  {
    EmpOfMonth: "Received nomination for employee of the month from Client",
    Appreciation: "Appreciation received from ATMECS for successful and persistent efforts across the project",
    NewsLetter: "A Module developed by me, was highlighted in newsletter for successfully meeting the deadlines way before than expected",
    SummitAward: "Received UiPath Summit Award for guiding IntegrationService Product and Engineering teams to achieve their targets"
};

export default class RecognitionsPage extends Component<any, any>{

    constructor(props: any){
        super(props);
        this.state = {
            selectedImgIndx: 0,
            EmpOfMonth: "UnselectedImage",
            Appreciation: "UnselectedImage",
            NewsLetter: "UnselectedImage",
            SummitAward: "SelectedImage",
            DescriptionDisplayStyle:{
                width: 0, height: 0, visibility: "hidden"
            },
            selectedImagePath: "SummitAward"
        }
    }

    render()
    {
        return(
            <div className="RecognitionsContainer h-100">
                <div className="row">
                    <div className="col">
                        <h1 className="text-center Title">RECOGNITIONS</h1>
                    </div>
                </div>
                
                <div className="ImagesDiv d-flex flex-wrap align-items-center justify-content-around">
                   
                    <div className="RecognitionCard d-flex flex-wrap justify-content-around">
                        <img src={SummitAward} 
                            className="RecognitionImage"
                            alt={SummitAward}/>
                        <div className="RecognitionDescription">
                            <p>{RecognitionsExplanation["SummitAward"]}</p>
                        </div>
                    </div>

                    <div className="RecognitionCard d-flex flex-wrap justify-content-around">
                        <img src={EmpOfMonth} 
                            className="RecognitionImage"
                            alt={EmpOfMonth}/>
                        <div className="RecognitionDescription">
                            <p>{RecognitionsExplanation["EmpOfMonth"]}</p>
                        </div>
                    </div>

                    <div className="RecognitionCard d-flex flex-wrap justify-content-around">
                        <img src={NewsLetter} 
                            className="RecognitionImage"
                            alt={NewsLetter}/>
                        <div className="RecognitionDescription">
                            <p>{RecognitionsExplanation["NewsLetter"]}</p>
                        </div>
                    </div>

                    <div className="RecognitionCard d-flex flex-wrap justify-content-around">
                        <img src={Appreciation} 
                            className="RecognitionImage"
                            alt={Appreciation}/>
                        <div className="RecognitionDescription">
                            <p>{RecognitionsExplanation["Appreciation"]}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}